// @deprecated File mutations are retired for the Adorans read-only workspace.
import yjsDocumentService from "../../../infrastructure/sync/YjsDocumentService";
import { getWorkspaceId } from "../../../shared/services/dbUtils";
import { createOperationMetadata } from "../../../shared/services/metadata/metadataUtils";
import { sanitizeFileName, sanitizeFolderName } from "../../../shared/services/utils";

export const createFile = (
  { parentPath = '', fileName, content = '' },
  setSelectedFile,
  editorFileChanged,
  fileSavedToDatabase
) => {
  if (!fileName) return false;

  // Sanitize the file name
  const sanitizedFileName = sanitizeFileName(fileName);
  if (!sanitizedFileName) return false;

  const cleanParentPath = parentPath.replace(/^\/+|\/+$/g, '');
  const fullPath = cleanParentPath
    ? `${cleanParentPath}/${sanitizedFileName}${!sanitizedFileName.endsWith('.txt') ? '.txt' : ''}`
    : `${sanitizedFileName}${!sanitizedFileName.endsWith('.txt') ? '.txt' : ''}`;

  const fileData = {name: fullPath, content: content, found: true};
  setSelectedFile(fileData);
  editorFileChanged.postMessage({fileName: fullPath, fileContent: content});
  fileSavedToDatabase.postMessage({fileName: fullPath});

  return fullPath;
};

export const createFolder = ({ parentPath = '', folderName }) => {
  if (!folderName) return false;

  // Sanitize the folder name using the specialized function that removes dots
  const sanitizedFolderName = sanitizeFolderName(folderName);
  if (!sanitizedFolderName) return false;

  const cleanParentPath = parentPath.replace(/^\/+|\/+$/g, '');
  const fullPath = cleanParentPath
    ? `${cleanParentPath}/${sanitizedFolderName}`
    : sanitizedFolderName;

  return fullPath;
};

export const renameItem = ({ oldPath, newName, isFolder = false }, selectedFile, setSelectedFile, editorFileChanged, fileRenamedEvent) => {
  if (!newName) return false;

  let formattedName;
  
  // Use different sanitization for folders vs files
  if (isFolder) {
    // For folders: use sanitizeFolderName to remove dots and prevent extensions
    const sanitizedFolderName = sanitizeFolderName(newName);
    if (!sanitizedFolderName) return false;
    formattedName = sanitizedFolderName;
  } else {
    // For files: use standard sanitization and ensure .txt extension
    const sanitizedFileName = sanitizeFileName(newName);
    if (!sanitizedFileName) return false;
    // Strip .txt if it exists, then add it back to ensure consistency
    formattedName = sanitizedFileName.replace(/\.txt$/, '') + '.txt';
  }

  const pathParts = oldPath.split('/');
  pathParts.pop();

  const parentPath = pathParts.join('/');
  const newPath = parentPath
    ? `${parentPath}/${formattedName}`
    : formattedName;

  // Create metadata using utility function
  const metadata = createOperationMetadata({
    action: 'rename',
    oldFileName: oldPath,
    fileName: newPath
  });

  // Update metadata for this file before rename
  const workspaceId = getWorkspaceId();
  yjsDocumentService.updateMetadata(workspaceId, metadata, oldPath);

  if (selectedFile && selectedFile.name === oldPath) {
    const updatedFile = {...selectedFile, name: newPath};
    setSelectedFile(updatedFile);
    editorFileChanged.postMessage({
      fileName: newPath,
      fileContent: selectedFile.content,
      oldFileName: oldPath,
      action: 'rename',
      metadata: metadata
    });
  } else {
    fileRenamedEvent.postMessage({
      oldFileName: oldPath,
      newFileName: newPath,
      fileName: newPath,
      action: 'rename',
      metadata: metadata
    });
  }

  return newPath;
};

export const deleteFile = ({ path }, selectedFile, setSelectedFile, navigate, fileDeletedEvent) => {
  if (selectedFile && selectedFile.name === path) {
    setSelectedFile({name: null, content: null, found: false});
    navigate('/');
  }

  // Create metadata using utility function
  const metadata = createOperationMetadata({
    action: 'delete'
  });
  
  // Update metadata for this file before deletion
  const workspaceId = getWorkspaceId();
  yjsDocumentService.updateMetadata(workspaceId, metadata, path);

  fileDeletedEvent.postMessage({
    fileName: path, 
    action: 'delete',
    metadata: metadata
  });

  return true;
};
